import React, { useRef, useState, useEffect } from 'react';
import {
  Box,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Spacer,
  Button,
  Textarea,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { SettingsModal } from '../../';
import { ChatContent } from './chatContent';
import { CommonChat } from './commonChat';
import { useTranslation } from 'react-i18next';
import { SendIcon } from '../../../images';

const ChablaChat = () => {
  const { t } = useTranslation();
  const commonChat = {
    title: 'chat',
  };

  const [otherChats, setOtherChats] = useState([]);

  const currentUser = 'Tea tulkki';

  const [chatContent, setChatContent] = useState([
    {
      to: undefined,
      from: 'Tea tulkki',
      content: 'Hei kaikille!',
      timestamp: Date(),
    },
    {
      to: 'you',
      from: 'Tea tulkki',
      content: 'Hei Sinulle!',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Kaisa',
      content: 'Hei Kaisalta!',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Kaisa',
      content: 'Mitä kuuluu?',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Erik',
      content: 'Hei Erikiltä!',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Erik',
      content: 'Hyvää, mitä sinne?',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Tea tulkki',
      content: 'Hei kaikille!',
      timestamp: Date(),
    },
    {
      to: 'you',
      from: 'Tea tulkki',
      content: 'Hei Sinulle!',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Kaisa',
      content: 'Hei Kaisalta!',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Kaisa',
      content: 'Mitä kuuluu?',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Erik',
      content: 'Hei Erikiltä!',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Erik',
      content: 'Hyvää, mitä sinne?',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Tea tulkki',
      content: 'Hei kaikille!',
      timestamp: Date(),
    },
    {
      to: 'you',
      from: 'Tea tulkki',
      content: 'Hei Sinulle!',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Kaisa',
      content: 'Hei Kaisalta!',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Kaisa',
      content: 'Mitä kuuluu?',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Erik',
      content: 'Hei Erikiltä!',
      timestamp: Date(),
    },
    {
      to: undefined,
      from: 'Erik',
      content: 'Hyvää, mitä sinne?',
      timestamp: Date(),
    },
  ]);

  // TODO REMOVE THIS, this is just used to easily open tabs / 1:1 chats.
  const clickParticipantHandler = (participant) => {
    if (otherChats.find((item) => item.title === participant.name) === undefined) {
      const newChatList = [
        ...otherChats,
        {
          title: participant.name,
        },
      ];
      setOtherChats(newChatList);
    }
  };

  const currentUserIsAdmin = true;
  const [participants, setParticipants] = useState([
    {
      name: currentUser,
      type: 'interpreter',
      isCurrentUser: true,
    },
    { name: 'Kaisa', type: undefined, isCurrentUser: false },
    { name: 'Erik', type: undefined, isCurrentUser: false },
  ]);

  const setUserType = (name, type) => {
    const participantsCopy = [...participants];
    participantsCopy.find((item) => item.name === name).type = type;

    setParticipants(participantsCopy);
  };

  const removeUser = (name) => {
    const participantsCopy = [...participants];
    const indexToRemove = participantsCopy.findIndex((item) => item.name === name);
    participantsCopy.splice(indexToRemove, 1);
    setParticipants(participantsCopy);
  };

  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const isOtherChatIndex = (index) => index > 0 && index < otherChats.length + 1;
  const isCommotChatIndex = (index) => index === 0;
  const removeCurrentChat = () => {
    if (isOtherChatIndex(currentTabIndex)) {
      const newChatList = [...otherChats];
      newChatList.splice(currentTabIndex - 1, 1);
      setOtherChats(newChatList);
    }

    setCurrentTabIndex(0);
  };

  const setTabIndex = (index) => {
    if (isCommotChatIndex(index) || isOtherChatIndex(index)) {
      setCurrentTabIndex(index);
    }
  };

  const [settingsOpen, setSettingsOpen] = useState(false);
  const openChatSettings = () => {
    setSettingsOpen(true);
  };

  const getNewMessageTo = () => {
    if (currentTabIndex == 0) {
      return undefined;
    }

    return otherChats[currentTabIndex - 1].title;
  };

  const sendMessage = () => {
    const val = textRef.current.value;
    if (!val) {
      return;
    }
    const newChatContent = [...chatContent];
    newChatContent.push({
      to: getNewMessageTo(),
      from: 'Tea tulkki',
      content: val,
      timestamp: Date(),
    });

    setChatContent(newChatContent);

    textRef.current.value = '';
    textRef.current.focus();
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatContent]);

  const textRef = useRef(null);
  const scrollRef = useRef(null);

  const scrollToBottom = () => {
    scrollRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <Box>
      <SettingsModal
        mode="chat"
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        size="xl"
        displayFooter={false}
        headerText={t('chat.settings.header')}
      />
      <Box flex="1" h="100%">
        <Tabs index={currentTabIndex} onChange={(index) => setTabIndex(index)}>
          <TabList bg="brand.110">
            <Tab
              bg="brand.110"
              _selected={{
                bg: 'brand.10',
                borderBottom: 'solid 2px #BA494C',
                borderLeft: 'solid 10px #ffffff',
                borderRight: 'solid 10px #ffffff',
              }}
              fontWeight="bold"
            >
              {commonChat.title}
            </Tab>
            {otherChats.map((chat, index) => (
              <Tab
                bg="brand.110"
                _selected={{
                  bg: 'brand.10',
                  borderBottom: 'solid 2px #BA494C',
                  borderLeft: 'solid 10px #ffffff',
                  borderRight: 'solid 10px #ffffff',
                }}
                key={'chat-tab-' + index}
                color="brand.60"
                fontWeight="bold"
              >
                {chat.title}
              </Tab>
            ))}
            <Spacer borderBottomWidth="0px" bg="brand.110" borderColor="brand.110" />
            <Tab
              bg="brand.110"
              borderLeftColor="white"
              borderLeftWidth="2px"
              borderLeftStyle="solid"
              onClick={removeCurrentChat}
            >
              <CloseIcon />
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel p={0}>
              <CommonChat
                chat={commonChat}
                chatContent={chatContent}
                tempClickHandler={clickParticipantHandler}
                participants={participants}
                setUserType={setUserType}
                removeUser={removeUser}
                currentUserIsAdmin={currentUserIsAdmin}
                openChatSettings={openChatSettings}
                scrollRef={scrollRef}
              />
            </TabPanel>
            {otherChats.map((chat, index) => (
              <TabPanel key={'chat-panel-' + index} height="60vh">
                <ChatContent
                  chatContent={chatContent}
                  filter={(msg) =>
                    (msg.to === currentUser || msg.from === currentUser) &&
                    (msg.to === chat.title || msg.from === chat.title)
                  }
                />
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      </Box>
      <Box bg="brand.50" height={100} mb={0}>
        <Button onClick={() => sendMessage()}>
          <SendIcon
            style={{
              position: 'relative',
              float: 'right',
            }}
            m={0}
            p={0}
          />
        </Button>
        <Textarea
          mt={0}
          resize="none"
          placeholder={t('chat.writeMessagePlaceholder')}
          ref={textRef}
        ></Textarea>
      </Box>
    </Box>
  );
};

ChablaChat.propTypes = {};

export default ChablaChat;
